export const showroomPath = {
  LIST: '',
  SHAXMATKA: '/shaxmatka',
  SHAXMATKA_PLUS: '/shaxmatka-plus',
  VISUAL: '/visual'
};
